/**
 * Capstone 7.8 shared config, tiers, and storage keys.
 * Ticket: caproj | Developer: ray | Date: 14/09/2026
 */
/* Added the following code for caproj.ray using AI Agent. 14/09/2026. Code Start */

export const CUSTOM_PROJECT_STORAGE_KEY = "selftrainai:custom-capstone-project";
export const TIER_STORAGE_KEY = "selftrainai:capstone-tier";
export const PROJECT_CHANGED_EVENT = "selftrainai:capstone-project-changed";
export const TIER_CHANGED_EVENT = "selftrainai:capstone-tier-changed";
/* Added the following code for newbie.ray using AI Agent. 02/10/2026. Code Start */
/** Fired after "Start a new project" so open capstone views drop their old state. */
export const PROJECT_RESET_EVENT = "selftrainai:capstone-project-reset";
/* Code end. ray using AI Agent. 02/10/2026 */

export const CAPSTONE_CONFIG = {
  PLATFORM_GATE_F1: "0.75",
  SHARED_CLASSES: "positive, negative, neutral",
  ACCEPTANCE_PASS_TOKEN: "ACCEPTANCE CRITERIA MET",
  ACCEPTANCE_FAIL_TOKEN: "REVISION NEEDED",
  MIN_CLASSES: 2,
  MAX_CLASSES: 5,
  MIN_SAMPLES_PER_CLASS: 2,
  MIN_TOTAL_SAMPLES: 6,
  CONFIDENCE_REVIEW_THRESHOLD: 0.35,
};

/* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
/** Native Capstone overview (§7.8) with 7 Archetypes & 5 SDLC stages. */
export const CAPSTONE_OVERVIEW_PATH = "/your-capstone-project";
export const CAPSTONE_HUB_PATH = "/your-capstone-project";

/* Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start */
// /**
//  * Workshop URLs — interactive Capstone studios (archetype labs, gates, handoff).
//  * Menu leaves (/capstone-requirements, …) stay curriculum-first; Apply opens these.
//  */
// export const CAPSTONE_WORKSHOP_PATHS = {
//   scope: "/capstone-workshop/requirements",
//   design: "/capstone-workshop/design",
//   build: "/capstone-workshop/implementation",
//   verify: "/capstone-workshop/testing",
//   ship: "/capstone-workshop/deployment",
// };
/* Commenting end. ray using AI Agent. Sep 27, 2026 */
/* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
/**
 * Phase URLs — one route per SDLC phase; each menu leaf renders the interactive
 * workshop (archetype labs, gates, handoff). Legacy /capstone-workshop/* URLs
 * redirect here from App.jsx. Kept as a separate map so existing consumers
 * (PhaseNav, status, hub, labs) follow automatically; equals SDLC_PHASES[].path.
 */
export const CAPSTONE_WORKSHOP_PATHS = {
  /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
  plan: "/capstone-planning",
  analysis: "/capstone-analysis",
  /* Code end. ray using AI Agent. Sep 27, 2026 */
  scope: "/capstone-requirements",
  design: "/capstone-design",
  build: "/capstone-implementation",
  verify: "/capstone-testing",
  ship: "/capstone-deployment-handoff",
};
/* Code end. ray using AI Agent. Sep 27, 2026 */

export const CAPSTONE_WORKSHOP_COPY = {
  /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
  plan: {
    tryTitle: "Apply in Capstone workspace",
    /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
    tryBody:
      "Share your idea in a sentence or two. Capstone pre-fills an idea check and a Project Charter (goal, success indicator, scope, constraints, milestones) for you to review.",
    /* Code end. ray using AI Agent. Sep 27, 2026 */
    /* Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start */
    // tryBody:
    //   "Validate that your own idea is specific enough to plan, then write a Project Charter: problem, users, goal, success indicator and scope.",
    /* Commenting end. ray using AI Agent. Sep 27, 2026 */
    tryCta: "Open Planning workshop",
  },
  analysis: {
    tryTitle: "Apply in Capstone workspace",
    /* Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start */
    // tryBody:
    //   "Analyse the current process and your cases, compare AI approaches (rules, ML, LLM, human, hybrid), log risks and assess feasibility.",
    /* Commenting end. ray using AI Agent. Sep 28, 2026 */
    /* Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start */
    tryBody:
      "Analyse the current process and your cases, compare approaches (rules, a formula or lookup, ML, LLM, human, hybrid), log risks and assess feasibility.",
    /* Code end. ray using AI Agent. Sep 28, 2026 */
    tryCta: "Open Analysis workshop",
  },
  /* Code end. ray using AI Agent. Sep 27, 2026 */
  scope: {
    tryTitle: "Apply in Capstone workspace",
    /* Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start */
    /* Added the following code for newbie_capstone.ray using AI Agent. Sep 24, 2026. Code Start */
    // tryBody:
    //   "Bring your NLP product idea, optionally peek at course sparks, and write your problem brief — then code it in Python later.",
    /* Code end. ray using AI Agent. Sep 24, 2026 */
    /* Commenting end. ray using AI Agent. Sep 28, 2026 */
    /* Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start */
    tryBody:
      "Bring your product idea, split your full vision from the Capstone Build, and write your requirements — then code it in Python later.",
    /* Code end. ray using AI Agent. Sep 28, 2026 */
    /* Commenting the following code for newbie_capstone.ray using AI Agent. Sep 24, 2026. Comment Start */
    // tryBody:
    //   "Choose your product archetype, pick a starter, and write your problem brief in the Capstone workspace — the same hands-on studio used for the rest of the SDLC.",
    /* Commenting end. ray using AI Agent. Sep 24, 2026 */
    tryCta: "Open Requirements workshop",
  },
  design: {
    tryTitle: "Apply in Capstone workspace",
    /* Added the following code for newbie_capstone.ray using AI Agent. Sep 24, 2026. Code Start */
    tryBody:
      "Lock a function contract and acceptance cases (or labels/examples for archetype mode) in the Capstone workspace.",
    /* Code end. ray using AI Agent. Sep 24, 2026 */
    tryCta: "Open Design workshop",
    checkTitle: "Check & lock in workspace",
    checkBody: "Run the design envelope checks and lock your contract in the workshop.",
    checkCta: "Open Design workshop (Check it)",
  },
  build: {
    tryTitle: "Build in Capstone workspace",
    /* Added the following code for newbie_capstone.ray using AI Agent. Sep 24, 2026. Code Start */
    /* Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start */
    // tryBody:
    //   "Implement process(text) in the Monaco Python lab (Run / Vibe-code). Open mode always codes in-platform.",
    /* Commenting end. ray using AI Agent. Sep 28, 2026 */
    /* Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start */
    tryBody:
      "Implement process(data) in the Monaco Python lab (Run / Vibe-code). Open mode always codes in-platform.",
    /* Code end. ray using AI Agent. Sep 28, 2026 */
    /* Code end. ray using AI Agent. Sep 24, 2026 */
    tryCta: "Open Implementation workshop",
    checkTitle: "Measure in Capstone workspace",
    checkBody: "Confirm your build (acceptance smoke or practice Macro-F1) in the workshop.",
    checkCta: "Open Implementation workshop (Check it)",
  },
  verify: {
    tryTitle: "Test in Capstone workspace",
    /* Added the following code for newbie_capstone.ray using AI Agent. Sep 24, 2026. Code Start */
    tryBody: "Re-run your acceptance cases (or held-out / edge tests) against your code in the workshop.",
    /* Code end. ray using AI Agent. Sep 24, 2026 */
    tryCta: "Open Testing workshop",
    checkTitle: "Pass the gate in workspace",
    checkBody: "Complete the hard verification gate for your project in the workshop.",
    checkCta: "Open Testing workshop (Check it)",
  },
  ship: {
    tryTitle: "Ship in Capstone workspace",
    tryBody: "Rehearse the live demo and prepare handoff artifacts in the workshop.",
    tryCta: "Open Deployment workshop",
    checkTitle: "Sign off in Capstone workspace",
    checkBody: "Download your portfolio kit, write your reflection, and graduate in the workshop.",
    checkCta: "Open Deployment workshop (Check it)",
  },
};

/**
 * Default CMS narrative for the 7.8 folder hub (RootSubmenu).
 * Shown when pageInformation is empty or still "Default Content".
 * Admins can replace it via Quill on the hub page.
 */
export const CAPSTONE_FOLDER_OVERVIEW_HTML = `
<div style="font-size: 14px; line-height: 1.7; color: #1e293b;">
  <p><strong>7.8 Your Capstone Project — what you will do here</strong></p>
  <!-- Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start
  <p>
    This section is where you <strong>build your own Capstone NLP project</strong> end to end —
    bring an open idea, write acceptance cases, implement <code>process(text)</code> in Python,
    verify honestly, and hand off documentation.
  </p>
  Commenting end. ray using AI Agent. Sep 28, 2026 -->
  <!-- Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start -->
  <p>
    This section is where you <strong>build your own Capstone project</strong> end to end —
    bring an open idea (any kind of software), write acceptance cases, implement <code>process(data)</code> in Python,
    verify honestly, and hand off documentation.
  </p>
  <!-- Code end. ray using AI Agent. Sep 28, 2026 -->
  <p>
    Earlier chapters gave you the building blocks (rules, classical ML, neural nets, transformers, LLMs, safety).
    Here you apply them to <strong>one product idea you own</strong>: scope it, design the contract, code it,
    test it honestly, and hand it off with clear documentation.
  </p>

  <p><strong>How this subfolder is organized</strong></p>
  <p>
    Use the menus under <strong>7.8</strong> in the sidebar. Each child topic is one SDLC stage.
    Complete them in order so your project stays coherent from brief → ship.
  </p>
  <!-- Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start -->
  <ul style="padding-left: 20px; margin-top: 8px; margin-bottom: 8px;">
    <li>
      <strong>7.8.1 Planning</strong> —
      <!-- Commenting the following code for newbie.ray using AI Agent. 01/10/2026. Comment Start
      Check that your own idea is specific enough (problem, users, AI role, technique, why AI), then write a Project Charter with a measurable goal and scope.
      Commenting end. ray using AI Agent. 01/10/2026 -->
      <!-- Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start -->
      Describe what you want to build (problem, users, what goes in and what comes out) and save your idea.
      <!-- Code end. ray using AI Agent. 01/10/2026 -->
    </li>
    <li>
      <strong>7.8.2 Requirements</strong> —
      <!-- Commenting the following code for newbie.ray using AI Agent. 01/10/2026. Comment Start
      Write a clear problem brief and a mini SRS: functional, non-functional and AI requirements plus Given/When/Then acceptance criteria.
      Commenting end. ray using AI Agent. 01/10/2026 -->
      <!-- Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start -->
      Write a clear problem brief and a mini SRS: functional and non-functional requirements plus Given/When/Then acceptance criteria.
      <!-- Code end. ray using AI Agent. 01/10/2026 -->
    </li>
    <li>
      <strong>7.8.3 Analysis</strong> —
      <!-- Commenting the following code for newbie.ray using AI Agent. 01/10/2026. Comment Start
      Analyse the current process and your cases, compare AI approaches, log risks and assess feasibility.
      Commenting end. ray using AI Agent. 01/10/2026 -->
      <!-- Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start -->
      Analyse the current process and your cases, compare ways to build it (manual, plain code or AI), log risks and assess feasibility.
      <!-- Code end. ray using AI Agent. 01/10/2026 -->
    </li>
    <li>
      <strong>7.8.4 Design</strong> —
      Lock a function contract and at least three acceptance cases so Implementation has a firm, testable target.
    </li>
    <li>
      <strong>7.8.5 Implementation</strong> —
      <!-- Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start
      Build in the Monaco Python lab (Run / Vibe-code). Implement <code>process(text)</code> for your idea.
      Commenting end. ray using AI Agent. Sep 28, 2026 -->
      <!-- Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start -->
      Build in the Monaco Python lab (Run / Vibe-code). Implement <code>process(data)</code> for your idea.
      <!-- Code end. ray using AI Agent. Sep 28, 2026 -->
    </li>
    <li>
      <strong>7.8.6 Testing</strong> —
      Re-run your acceptance cases against your code. Pass enough of them honestly before Ship.
    </li>
    <li>
      <strong>7.8.7 Deployment &amp; Maintenance</strong> —
      <!-- Commenting the following code for newbie.ray using AI Agent. 01/10/2026. Comment Start
      Plan monitoring and maintenance, map your AI learning evidence, export your portfolio kit and sign off.
      Commenting end. ray using AI Agent. 01/10/2026 -->
      <!-- Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start -->
      Plan monitoring and maintenance, map your learning evidence, export your portfolio kit and sign off.
      <!-- Code end. ray using AI Agent. 01/10/2026 -->
    </li>
  </ul>
  <!-- Code end. ray using AI Agent. Sep 27, 2026 -->
  <!-- Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start
  <ul style="padding-left: 20px; margin-top: 8px; margin-bottom: 8px;">
    <li><strong>7.8.1 Requirements</strong> — Write a clear problem brief …</li>
    <li><strong>7.8.2 Design</strong> — Lock a function contract …</li>
    <li><strong>7.8.3 Implementation</strong> — Build in the Monaco Python lab …</li>
    <li><strong>7.8.4 Testing</strong> — Re-run your acceptance cases …</li>
    <li><strong>7.8.5 Deployment &amp; Handoff</strong> — Export your portfolio kit …</li>
  </ul>
  Commenting end. ray using AI Agent. Sep 27, 2026 -->

  <p><strong>What “done” looks like</strong></p>
  <p>
    <!-- Commenting the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Comment Start
    By the end of 7.8 you should have a small but complete NLP product story:
    Commenting end. ray using AI Agent. Sep 28, 2026 -->
    <!-- Added the following code for compileroverride.ray using AI Agent. Sep 28, 2026. Code Start -->
    By the end of 7.8 you should have a small but complete product story:
    <!-- Code end. ray using AI Agent. Sep 28, 2026 -->
    a scoped problem, a locked design, a working implementation, evidence from testing, and a handoff package —
    not just a notebook experiment.
  </p>
  <p>
    <!-- Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start -->
    <strong>Next step:</strong> open <strong>7.8.1 Planning</strong> in the sidebar and validate your idea.
    <!-- Code end. ray using AI Agent. Sep 27, 2026 -->
    <!-- Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start
    <strong>Next step:</strong> open <strong>7.8.1 Requirements</strong> in the sidebar and start your brief.
    Commenting end. ray using AI Agent. Sep 27, 2026 -->
  </p>
</div>
`.trim();
/* Code end. ray using AI Agent. 2026-09-24 */

export const CAPSTONE_TIERS = [
  {
    id: "foundation",
    icon: "1",
    name: "Foundation",
    subtitle: "Visual rule lab",
    description: "Keyword chips and weight sliders against your project samples — no Python required.",
    badge: "Visual lab",
  },
  {
    id: "developer",
    icon: "2",
    name: "Developer",
    subtitle: "Guided Python lab",
    description: "Monaco editor with ModularNlpPipeline and Macro-F1 gate against your samples.",
    badge: "Python lab",
  },
  {
    id: "advanced",
    icon: "3",
    name: "Advanced",
    subtitle: "Vectors + API export",
    description: "Class centroids, Softmax calibration, and FastAPI / pytest portfolio export.",
    badge: "ML + API",
  },
];

/* Added the following code for capstoneredesign.ray using AI Agent. 17/09/2026. Code Start */
/** Active Implementation paths this sprint — Advanced deferred until centroids land. */
/* Added the following code for imple.ray using AI Agent. Sep 21, 2026. Code Start */
/** Active Implementation labs — Developer (Python) only; Foundation path removed. */
export const BUILD_PATH_TIERS = CAPSTONE_TIERS.filter((t) => t.id === "developer");
/* Code end. ray using AI Agent. Sep 21, 2026 */
/* Commenting the following code for imple.ray using AI Agent. Sep 21, 2026. Comment Start */
// export const BUILD_PATH_TIERS = CAPSTONE_TIERS.filter(
//   (t) => t.id === "foundation" || t.id === "developer"
// );
/* Commenting end. ray using AI Agent. Sep 21, 2026 */
/* Code end. ray using AI Agent. 17/09/2026 */

/** Sentiment taxonomy used by seeded Foundation lexicons. */
export const SENTIMENT_CLASSES = ["positive", "negative", "neutral"];

/*
 * Array order = learner-facing order (7.8.1 … 7.8.7). `id` is the number stored in
 * project.completedPhases, so existing ids 1–5 never change; Planning = 6, Analysis = 7.
 */
export const SDLC_PHASES = [
  /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
  {
    id: 6,
    key: "capstone-planning",
    path: "/capstone-planning",
    workshopPath: CAPSTONE_WORKSHOP_PATHS.plan,
    hubPath: CAPSTONE_HUB_PATH,
    title: "Planning",
    subtitle: "Idea check & charter",
    phaseKey: "plan",
  },
  /* Code end. ray using AI Agent. Sep 27, 2026 */
  {
    id: 1,
    key: "capstone-requirements",
    path: "/capstone-requirements",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    workshopPath: CAPSTONE_WORKSHOP_PATHS.scope,
    hubPath: CAPSTONE_HUB_PATH,
    /* Code end. ray using AI Agent. 2026-09-24 */
    /* Commenting the following code for caps.ray using AI Agent. 2026-09-24. Comment Start */
    // hubPath: CAPSTONE_HUB_PATH,
    /* Commenting end. ray using AI Agent. 2026-09-24 */
    /* Added the following code for capstone.ray using AI Agent. Sep 18, 2026. Code Start */
    title: "Requirements",
    subtitle: "Scope & brief",
    /* Code end. ray using AI Agent. Sep 18, 2026 */
    /* Commenting the following code for capstone.ray using AI Agent. Sep 18, 2026. Comment Start */
    // title: "Scope",
    // subtitle: "Requirements",
    /* Commenting end. ray using AI Agent. Sep 18, 2026 */
    phaseKey: "scope",
  },
  /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
  {
    id: 7,
    key: "capstone-analysis",
    path: "/capstone-analysis",
    workshopPath: CAPSTONE_WORKSHOP_PATHS.analysis,
    title: "Analysis",
    subtitle: "Feasibility & risks",
    phaseKey: "analysis",
  },
  /* Code end. ray using AI Agent. Sep 27, 2026 */
  {
    id: 2,
    key: "capstone-design",
    path: "/capstone-design",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    workshopPath: CAPSTONE_WORKSHOP_PATHS.design,
    /* Code end. ray using AI Agent. 2026-09-24 */
    title: "Design",
    subtitle: "Contract & architecture",
    phaseKey: "design",
  },
  {
    id: 3,
    key: "capstone-implementation",
    path: "/capstone-implementation",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    workshopPath: CAPSTONE_WORKSHOP_PATHS.build,
    /* Code end. ray using AI Agent. 2026-09-24 */
    /* Added the following code for capstone.ray using AI Agent. Sep 18, 2026. Code Start */
    title: "Implementation",
    subtitle: "Build · measure · tune",
    /* Code end. ray using AI Agent. Sep 18, 2026 */
    /* Commenting the following code for capstone.ray using AI Agent. Sep 18, 2026. Comment Start */
    // title: "Build",
    // subtitle: "Implementation",
    /* Commenting end. ray using AI Agent. Sep 18, 2026 */
    phaseKey: "build",
  },
  {
    id: 4,
    key: "capstone-testing",
    path: "/capstone-testing",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    workshopPath: CAPSTONE_WORKSHOP_PATHS.verify,
    /* Code end. ray using AI Agent. 2026-09-24 */
    /* Added the following code for capstone.ray using AI Agent. Sep 18, 2026. Code Start */
    title: "Testing",
    subtitle: "Held-out & edges",
    /* Code end. ray using AI Agent. Sep 18, 2026 */
    /* Commenting the following code for capstone.ray using AI Agent. Sep 18, 2026. Comment Start */
    // title: "Verify",
    // subtitle: "Edge testing",
    /* Commenting end. ray using AI Agent. Sep 18, 2026 */
    phaseKey: "verify",
  },
  {
    id: 5,
    key: "capstone-deployment-handoff",
    path: "/capstone-deployment-handoff",
    /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
    workshopPath: CAPSTONE_WORKSHOP_PATHS.ship,
    /* Code end. ray using AI Agent. 2026-09-24 */
    /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
    title: "Deployment & Maintenance",
    subtitle: "Ship, monitor & hand off",
    /* Code end. ray using AI Agent. Sep 27, 2026 */
    /* Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start */
    // title: "Deployment",
    // subtitle: "Handoff & ship",
    /* Commenting end. ray using AI Agent. Sep 27, 2026 */
    /* Commenting the following code for capstone.ray using AI Agent. Sep 18, 2026. Comment Start */
    // title: "Ship",
    // subtitle: "Deployment",
    /* Commenting end. ray using AI Agent. Sep 18, 2026 */
    phaseKey: "ship",
  },
];

/* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
/** Display number (7.8.<step>) = position in SDLC_PHASES; use this, not `id`, in UI labels. */
SDLC_PHASES.forEach((phase, index) => {
  phase.step = index + 1;
});
/* Code end. ray using AI Agent. Sep 27, 2026 */

export const HUB_PAGE_PATH = "ch-7-real-world-applications-78-your-capstone-project";

export const PHASE_CMS_PATHS = {
  /* Added the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Code Start */
  plan: "capstone-planning",
  analysis: "capstone-analysis",
  /* Code end. ray using AI Agent. Sep 27, 2026 */
  scope: "capstone-requirements",
  design: "capstone-design",
  build: "capstone-implementation",
  verify: "capstone-testing",
  ship: "capstone-deployment-handoff",
  hub: HUB_PAGE_PATH,
};

/* Code end. ray using AI Agent. 14/09/2026 */
